import { useQuery } from 'react-query';
import * as api from '../../services/api';
import useAccount from './useAccount';

export const useClientOrders = (clientId) => {
  const { accountId } = useAccount();

  const { isLoading, data, refetch } = useQuery(
    ['clientOrders', accountId, clientId],
    () =>
      api.fetchClientOrders({
        accountId,
        clientId
      }),
    {
      cacheTime: 0
    }
  );

  return {
    refetch,
    isLoading,
    data: data?.data || []
  };
};
